<template>
  <div v-if="model">
    <div class="position-relative">
      <input type="text" v-model="textValue" class="form-control form-control-solid" :placeholder="model.name"
             @keyup="validate" :disabled="isDisabled" @change="validate">
      <div class="input-check">
        <i class="fad fa-check-circle text-primary px-3"></i>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import {helper} from "@/services/Helper";

@Component({})
export default class PropertyAmount extends Vue {
  @Prop() itemUuid!: string
  @Prop() propertyCode!: string
  @Prop({default: false}) isDisabled!: boolean

  textValue = ''

  get item() {
    return this.$store.getters["contractStore/getEntity"]('items', this.itemUuid)
  }

  get model() {
    if (!this.item) return null
    const itemType = this.$store.state.contractStore.itemTypes[this.item.modelCode]
    if (!itemType?.properties) return null
    return (Object.values(itemType.properties) as any[]).find((pm: any) => pm.code === this.propertyCode) || null
  }

  mounted() {
    this.textValue = this.item?.properties?.[this.propertyCode] || ''
  }

  validate() {
    this.format()
    this.$emit('propertyUpdated', {code: this.propertyCode, itemUuid: this.itemUuid})
  }

  format() {
    if (this.textValue) {
      let current = (this.textValue + '').replace(/\s/g, '')
      if (isNaN(parseFloat(current))) {
        return
      }
      let formated = helper.currencyFormat(current, false, false);
      if (formated !== this.textValue) {
        this.textValue = formated
        if (this.item) {
          Vue.set(this.item.properties, this.propertyCode, current)
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
